import React, { useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import { Button } from '@/components/ui/button';
import { Feather, Flame, Download, Loader2 } from 'lucide-react';

export const ShareBadge = ({ user, stats }) => {
  const badgeRef = useRef(null);
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    if (!badgeRef.current) return;
    setDownloading(true);
    try {
      const canvas = await html2canvas(badgeRef.current, { backgroundColor: null, scale: 2, logging: false });
      const link = document.createElement('a');
      link.download = 'flash_fiction_badge.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    } catch (err) {
      console.error('Badge export failed:', err);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div data-testid="share-badge-section">
      <div
        ref={badgeRef}
        className="rounded-2xl p-8 text-center"
        style={{ background: 'linear-gradient(135deg, #78350f 0%, #9a3412 55%, #be123c 100%)' }}
        data-testid="share-badge-card"
      >
        <div className="flex justify-center mb-3">
          <div className="bg-amber-50/20 p-3 rounded-full">
            <Feather className="h-7 w-7 text-amber-100" />
          </div>
        </div>
        <p className="font-display text-2xl font-bold text-amber-50">{user?.name}</p>
        <div className="flex items-center justify-center space-x-2 mt-2 text-amber-100">
          <Flame className="h-5 w-5 text-orange-300" />
          <span className="font-display text-3xl font-bold" data-testid="badge-streak">
            {stats.current_streak} day{stats.current_streak === 1 ? '' : 's'}
          </span>
          <span className="text-amber-200/80">writing streak</span>
        </div>
        <p className="text-amber-100/90 mt-3 text-sm" data-testid="badge-stats">
          {stats.total_stories} {stats.total_stories === 1 ? 'story' : 'stories'} &middot; {stats.total_words} words &middot; {stats.total_reactions} hearts
        </p>
        <p className="font-serif-italic text-amber-200/70 text-xs mt-4">Written on Flash Fiction</p>
      </div>
      <Button
        variant="outline"
        onClick={handleDownload}
        disabled={downloading}
        className="w-full mt-3 border-amber-300 text-amber-800 hover:bg-amber-100"
        data-testid="download-badge-button"
      >
        {downloading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Preparing&hellip;
          </>
        ) : (
          <>
            <Download className="mr-2 h-4 w-4" />
            Download badge to share
          </>
        )}
      </Button>
    </div>
  );
};
